import { Injectable } from '@angular/core';
import { formatDate } from '@angular/common';

@Injectable({
  providedIn: 'root',
})
export class DateService {

  convertDateFromYYYYmmDD(date: string) {
      const [year, month, day] = date.split('-');
      const newDate = new Date();
      newDate.setDate(+day);
      newDate.setFullYear(+year);
      newDate.setMonth(+month - 1);
      return newDate;
  }

  convertDateToYYYYmmDD(date: string) {
    const formattedDate = formatDate(date, 'yyyy-MM-dd', 'en')
    return formattedDate;
  }

  convertDateFromString(dateTime: string) {
    const [date, time] = dateTime.split(' ');
    const [year, month, day] = date.split('-');
    const [hh, mm, ss] = time.split(':');
    const formattedDate = new Date();
    formattedDate.setFullYear(+year);
    formattedDate.setMonth(+month - 1);
    formattedDate.setDate(+day);
    formattedDate.setHours(+hh);
    formattedDate.setMinutes((+mm));
    formattedDate.setSeconds(+ss);
    return formattedDate;
  }

  extractTimeFromDate(time: string) {
    const formatted = formatDate(time, 'HH:mm', 'en');
    return formatted;
  }

  extractTimeToDate(time: string, separator = ':') {
    const [hh, mm] = time.split(separator);
    const formattedTime = new Date();
    formattedTime.setHours(+hh);
    formattedTime.setMinutes(+mm);
    console.log(formattedTime);
    return formattedTime;
  }

  // extractTimeToDate(time: string): Date {
  //   const [hours, minutes, seconds] = time.split(':').map(Number);
  //   const formattedTime = new Date();
  //   formattedTime.setUTCHours(hours, minutes, seconds, 0);
  //   return formattedTime;
  // }

  dateForChat(date) {
    const dt = new Date(date);
    let shortMonth = dt.toLocaleString('en-us', { month: 'short' });
    var dayName = dt.toString().split(' ')[0];
    return `${dayName}, ${dt.getDate()} ${shortMonth}`;
  }

}
